/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ComplianceDetailsForPoliciesResponse {
    getFixupPrototypeFunction() { return ComplianceDetailsForPoliciesResponse.fixupPrototype; }

    static newInstance(model: Partial<ComplianceDetailsForPoliciesResponse>): ComplianceDetailsForPoliciesResponse {
        let obj = Object.assign(new ComplianceDetailsForPoliciesResponse(), model);
        ComplianceDetailsForPoliciesResponse.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ComplianceDetailsForPoliciesResponse>): ComplianceDetailsForPoliciesResponse {
        if (!model) return null;
        return ComplianceDetailsForPoliciesResponse.newInstance(<ComplianceDetailsForPoliciesResponse> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ComplianceDetailsForPoliciesResponse) {
        if (!obj) return;

        models.ComplianceDetailsForPoliciesResponse.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ComplianceDetailsForPoliciesResponse): boolean {
        Object.setPrototypeOf(obj, ComplianceDetailsForPoliciesResponse.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * Skip allowed true/false
     */
    skip_allowed: string;

    /**
     * resolution_status
     */
    resolution_status: string;

    /**
     * total_count
     */
    total_count: string;

    /**
     * page_count
     */
    page_count: string;

    /**
     * actions
     */
    actions: Array<any>;

    /**
     * policy_name
     */
    policy_name: string;

    /**
     * resource_counts
     */
    resource_counts: string;

    /**
     * impact
     */
    impact: string;

    /**
     * definition_id
     */
    definition_id: string;

}
